import React from 'react';
import { TextUtilities } from '@pwc/pwc-deals-web-common';
import { Icon } from '@pwc/pwc-deals-ui';
import { Link, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import EnableForProjectState from '../../security/EnableForProjectState';
import ShowForPermissions from '../../security/ShowForPermissions';
import './ContentLinkSubPanel.scss';
import useMobile from '../../../common/hooks/useMobile';

const ContentLinkSubPanel = ({
  contentType,
  contentListLinkTo,
  contentAddLinkTo,
  itemCount,
  contentListIconName,
}) => {
  const { projectId } = useParams();

  let addOrArrow = false;
  addOrArrow = itemCount >= 1;
  const isMobile = useMobile();

  return (
    <div
      className="project-overview-subpanel"
      data-testid="content-link-sub-panel"
    >
      <div className="nowrap">
        <Link to={contentListLinkTo} className="overview-title-link">
          <Icon
            name={contentListIconName}
            width={24}
            className="title-icon outline icon-grey hover-white"
          />
          <span
            className="title"
            data-testid={`${TextUtilities.slugify(contentType)}-overview`}
          >
            {`${contentType}: ${itemCount}`}
          </span>
        </Link>
      </div>
      {addOrArrow ? (
        <div className="showlist">
          <Link
            to={contentListLinkTo}
            data-testid={`${TextUtilities.slugify(contentType)}-link`}
            aria-label={contentType}
            className="access-content"
          >
            <Icon
              name="arrow-right"
              width={24}
              className="outline icon-orange"
            />
          </Link>
        </div>
      ) : (
        <ShowForPermissions projectId={projectId} permissions={['Contribute']}>
          <EnableForProjectState projectId={projectId}>
            {({ isProjectDisabled }) =>
              !isProjectDisabled && (
                <div className={isMobile ? 'addbutton-disabled' : 'addbutton'}>
                  <Link
                    to={contentAddLinkTo}
                    data-testid={`${TextUtilities.slugify(contentType)}-link`}
                    aria-label={contentType}
                    className="add-link"
                  >
                    <Icon
                      name="add"
                      width={24}
                      className="outline icon-orange"
                    />
                  </Link>
                </div>
              )
            }
          </EnableForProjectState>
        </ShowForPermissions>
      )}
    </div>
  );
};

ContentLinkSubPanel.propTypes = {
  contentType: PropTypes.string.isRequired,
  contentListLinkTo: PropTypes.string.isRequired,
  contentAddLinkTo: PropTypes.string.isRequired,
  itemCount: PropTypes.number.isRequired,
  contentListIconName: PropTypes.string.isRequired,
};

export default ContentLinkSubPanel;
